jQuery(document).ready(function() {
    var interval1 = setInterval(function() {
        if (document.readyState == "complete") {
            clearInterval(interval1);
            if (jQuery(".hero_banner_sec .content_wrap .image_one").length > 0) {
                jQuery(".hero_banner_sec .content_wrap .image_one").addClass("active");
            }
            if (jQuery(".hero_banner_sec .content_wrap .image_two").length > 0) {
                jQuery(".hero_banner_sec .content_wrap .image_two").addClass("active");
            }
        }
    }, 500);
    jQuery('.heading_content_with_center_icon .heading_content .heading').each(function() {
        let headingHeight = jQuery(this).height();
        jQuery(this).css({ "max-height": headingHeight });
    });
    jQuery(window).scroll(function() {
        jQuery('.heading_content_with_center_icon .heading_content .heading').each(function() {
            if (isScrolledIntoView(this) === true) {
                jQuery(this).addClass('active');
            }
        });
        jQuery('.latest_news_events_sec .news_list__item.first_news_item').each(function() {
            if (isScrolledIntoView(this) === true) {
                jQuery(this).addClass('active');
            }
        });
        jQuery('.left_image_with_image_content_box .image_section').each(function() {
            if (isScrolledIntoView(this) === true) {
                jQuery(this).addClass('active');
            }
        });
    });
})

function isScrolledIntoView(elem) {
    var docViewTop = jQuery(window).scrollTop();
    var docViewBottom = docViewTop + jQuery(window).height();

    var elemTop = jQuery(elem).offset().top + 200;
    var elemBottom = elemTop + jQuery(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}